module.exports = __webpack_public_path__ + "static/media/facebook.7e157804.svg";